import React, { useMemo } from 'react';
import { MentionsInput, Mention } from 'react-mentions';

const MentionInput = ({
    value,
    onChange,
    absentsData,
    placeholder,
    disabled 
}) => {

    const mentionUser = useMemo(() => {
        return absentsData.map(user => ({
            id: user.iAdminId,
            display: user.name || "",
            city: user.vCity || ""
        }));
    }, [absentsData]);

    const handleChange = (e, newValue, mentions) => {
           if (disabled) return;
        const validMentions = Array.isArray(mentions)
            ? mentions.filter(m =>
                mentionUser.some(u => u.id === m.id)
            )
            : [];

        
        onChange(newValue, validMentions);
    };

    return (
            <MentionsInput
                className="mentions planner-mentions"
                value={String(value)} 
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
            >
                <Mention
                    trigger="@"
                    data={mentionUser}
                    markup="@[__display__](__id__)"
                    displayTransform={(id, display) =>
                        `@${display.trim()} (${id})`
                    }
                    appendSpaceOnAdd
                    style={{ backgroundColor: '#e0f3ff' }}
                    renderSuggestion={(suggestion, search, highlightedDisplay) => (
                        <div style={{ padding: '5px 10px' }}>
                            <div>{highlightedDisplay}</div>
                            {suggestion.city && (
                                <small style={{ color: '#888' }}>
                                    {suggestion.city}
                                </small>
                            )}
                        </div>
                    )}
                />
            </MentionsInput>
    );
};

export default MentionInput;
